import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";
import usePath from "@/utils/hooks/client/usePath";

import { ResponseCountryOfPassportList } from "./utilitiesServiceInterface/countryOfPassportClass";

export class UtilitiesServiceApi {
  private baseUrl: string;

  private basePath: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "v5/utilities";
  }

  async getCountryOfPassport(): Promise<ResponseCountryOfPassportList | null> {
    try {
      const { dynamicImportJsonPath } = usePath();
      const responseJson: ResponseCountryOfPassportList =
        await dynamicImportJsonPath(`${this.basePath}/CountryOfPassportList`);

      if (responseJson && responseJson.status) {
        return new ResponseCountryOfPassportList(responseJson);
      }

      // Fallback to API request if responseJson is invalid
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePath}/CountryOfPassportList`,
        "GET",
      )) as any;
      return new ResponseCountryOfPassportList(response);
    } catch (error) {
      // console.error(error);
      return null;
    }
  }
}
